import { HttpParams } from '@angular/common/http';

export abstract class ParamsUtil {
  public static prepareParams(params: any, httpParams?: HttpParams): HttpParams {
    if (!httpParams) {
      httpParams = new HttpParams();
    }

    if (params == null) {
      return httpParams;
    }

    for (let key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined) {
        httpParams = httpParams.append(key, params[key]);
      }
    }

    return httpParams;
  }
}
